import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Fieldset } from 'primereact/fieldset'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { convertToFormatedDateString } from '../../../../services/util/date.service'

import {
  CustomDataTableHeader,
  CustomPanel,
  PageHeader,
  SelectEmpresas,
  Badge,
} from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'

import useCadastroOcPrevista, { LOAD_MESSAGE } from './CadastroOcPrevistaHook'
import OcPrevistaModal from './OcPrevistaModal/OcPrevistaModal'
import parseOCStatus from '../../../../constants/ordem-carregamento-status'

function CadastroOcPrevista({ selectedTp, dispatch, history }) {
  const { state, localDispatch } = useCadastroOcPrevista()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.INITIAL_GET:
        dispatch(showLoadingBox('Carregando ordens de carregamento previstas', 'Aguarde...'))
        localDispatch.getLista(state.selectedTp, state.filterCompanyId)
        break
      default:
        break
    }
  }, [state.loadingMessage, state.selectedTp, state.filterCompanyId])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetError()
    }
  }, [state.errorMessage])

  const header = (
    <CustomDataTableHeader
      onChange={value => localDispatch.onGlobalFilterChange(value)}
      value={state.globalFilter}
    />
  )

  return (
    <div>
      <PageHeader>8.20 - Ordem de Carregamento - Prevista</PageHeader>

      <div style={{ marginTop: 10 }}>
        <CustomPanel
          onNovo={() => localDispatch.onBtnNovo(selectedTp)}
          showBtnNovo={!!selectedTp}
          onVoltar={history.goBack}
        >
          <Fieldset
            legend="Filtro"
            toggleable
            collapsed
            className="p-col-12"
            style={{ marginTop: 10 }}
          >
            <div className="p-grid">
              <div className="p-col-4">
                <SelectEmpresas
                  companyId={state.filterCompanyId}
                  onChange={empresa => localDispatch.onFilterCompanyChange(empresa)}
                />
              </div>
            </div>
          </Fieldset>
          <DataTable
            header={header}
            value={state.itens}
            paginator
            rows={15}
            selectionMode="single"
            onRowClick={e => localDispatch.onRowClick(e.data)}
            globalFilter={state.globalFilter}
            emptyMessage="Nenhuma ordem prevista encontrada"
            dataKey="id"
            style={{ marginTop: 10 }}
          >
            <Column field="oc_code" header="Código OC" style={tableCellCentered()} />
            <Column field="company_name" header="Empresa" style={tableCellCentered()} />
            <Column field="lacre" header="Lacre" style={tableCellCentered()} />
            <Column field="destino" header="Destino" style={tableCellCentered()} />
            <Column field="placa" header="Placa" style={tableCellCentered()} />
            <Column
              field="data_expedicao"
              header="Data Expedição"
              body={row =>
                row.data_expedicao ? convertToFormatedDateString(row.data_expedicao) : ''
              }
              style={tableCellCentered()}
            />
            <Column
              field="status"
              header="Status"
              style={tableCellCentered()}
              body={utl => {
                const status = parseOCStatus(utl.status)
                return <Badge color={status.color}>{status.label}</Badge>
              }}
              bodyStyle={tableCellCentered()}
            />
          </DataTable>
        </CustomPanel>
      </div>

      <OcPrevistaModal
        show={state.modal.show}
        data={state.modal.data}
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(CadastroOcPrevista))
